import React from "react"
import { FormattedMessage } from "react-intl"
import "./CheckboxValidatorTitle.scss"
import ErrorMessage from "./ErrorMessage"

const CheckboxValidatorTitle: React.FC<{
	items: Array<string>
	title: string
}> = ({ items, title }) => {
	return (
		<div className="validator-sub-title">
			<b className="title">
				<FormattedMessage id={title} />
			</b>
			<ErrorMessage items={items} />
		</div>
	)
}

export default CheckboxValidatorTitle
